<template>
  <div
    v-if="dataModel[props.brandExperience].carouselFull"
    class="carousel-full"
    :class="`carousel-full--${props.iteration}`"
  >
    <div class="carousel-full__width">
      <div
        class="carousel-full__slide"
        v-for="(item, key) in dataModel[props.brandExperience].recipes"
        :key="item"
      >
        <div class="slide-wrapper">
          <div class="left-side">
            <img
              :src="pre + 'serves/serve-' + key + '-splash.png'"
              :class="'serve-img serve-img-' + key"
            />
          </div>
          <div class="right-side">
            <img
              :src="pre + 'serves/serve-text-' + key + '.png'"
              :class="'serve-text-img serve-text-img-' + key"
            />
            <div class="btns-wrapper">
              <button
                class="carousel__button2"
                data-action="csWidgetOpen"
                :data-id="key"
                @click="getIndex(key)"
              >
                <img
                  :src="`${pre}serves/make-it.png`"
                  style="width: 250px"
                  class="recipe-btn"
                />
              </button>
              <button
                class="carousel__button"
                data-action="csWidgetOpen"
                :data-id="2"
              >
                <img :src="`${pre}buy.png`" class="buy-btn" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img :src="`${pre}hero/Gold_border.jpg`" class="gold-border" style="z-index: 10" />

    <div>
      <img
        id="next-arrow"
        :class="`carousel-full__next--${props.iteration}`"
        :src="`${pre}next.svg`"
      />

      <span class="next">NEXT</span>
    </div>
    <div>
      <img
        id="prev-arrow"
        :class="`carousel-full__previous--${props.iteration}`"
        :src="`${pre}prev.svg`"
      />
      <span class="prev">PREV</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      indx: 0,
    };
  },
  methods: {
    //emit clicked product index
    getIndex(index) {
      this.$emit("activeRecipe", index);
      if (index == 0) {
        this.indx = 1;
      } else if (index == 4) {
        this.indx = 3;
      } else if (index == 5) {
        this.indx = 2;
      }
    },
  },
};
</script>

<script setup>
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
  active: {
    type: Number,
    default: 1,
  }, 
  pre: {
    type: String,
    default: "1",
  }, 
});
var carouselIteration = "carousel-full--" + props.iteration;
$(document).ready(function () {
  $("." + carouselIteration).prepend();
  $(".carousel-full__width").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var CurrentSlideDom = $(slick.$slides.get(currentSlide));
      var NextSlideDom = $(slick.$slides.get(nextSlide));
      var t = props.active;
      console.log(CurrentSlideDom);
      console.log(props.active);
    }
  );

  $(".carousel-full__width").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".carousel-full__previous--" + props.iteration),
    nextArrow: $(".carousel-full__next--" + props.iteration),
    responsive: [
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.carousel-full {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  position: relative;
  width: 100%;
  width: 100vw;
  min-height: 650px;
  max-width: 100vw;
  overflow: hidden;
  margin-top: -70px;
}
.gold {
  position: absolute;
  // top: 0;
  left: 0;
  width: 100vw;
  z-index: 2;
}
.next {
  position: absolute;
  right: 25px;
  top: bottom;
  font-family: CaptainRefined, sans-serif;
  margin-top: 25px;
  color: white;
  font-weight: 100;
  font-size: 14px;
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.prev {
  position: absolute;
  left: 25px;
  top: bottom;
  font-family: CaptainRefined, sans-serif;
  margin-top: 25px;
  color: white;
  font-weight: 100;
  font-size: 14px;
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.left-side {
  width: 38%;
  @media (max-width: 950px) {
    width: 42%;
  }
}
.carousel__button2 {
  margin-bottom: 10px;
}
.gold-bg-1 {
  width: 325px;
}
.gold-bg-2 {
  width: 335px;
}
.gold-bg-3 {
  top: 15px;
  width: 320px;
}
.gold-bg-4 {
  top: 10px;
  width: 315px;
}
.serve-text-img-1 {
  width: 220px;
}
.serve-text-img-2 {
  width: 250px;
  margin-top: 105px;
}
.serve-text-img-3 {
  margin-top: 100px;
  width: 210px;
}
.serve-text-img-4 {
  width: 265px;
  margin-top: 140px;
}
.serve-text-img-5 {
  width: 200px;
}
.serve-text-img-6 {
  width: 220px;
  margin-bottom: -35px;
}
.serve-img {
  width: 380px;
  margin-top: 120px;
}
.carousel-full__width {
  max-width: 1124px;
  padding: 0px 50px;
  position: relative;
  width: 100%;
  @media (max-width: $width--s) {
    padding: 0px;
  }
}
.gold-bg {
  position: absolute;
  z-index: -1;
}
.serve-text-img-3 {
  width: 210px;
}
.recipe-btn {
  width: 200px !important;
}
.buy-btn {
  width: 200px !important;
}
.right-side {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.serve-text-img {
  //   width: 265px;
  margin-top: 90px;
}
.btns-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.slide-wrapper {
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
#next-arrow {
  width: 40px;
  height: 43.73px;
}
#prev-arrow {
  width: 40px;
  height: 43.73px;
  position: relative;
  z-index: 1000;
}
.carousel-full__column {
  &--1 {
    @include flexbox();
    @include align-items(flex-start);
    @include justify-content(flex-start);
    @include flex-direction(column);
    width: 60%;
  }
  &--2 {
    @include flexbox();
    @include align-items(flex-start);
    @include justify-content(center);
    width: 30%;
    padding-bottom: 50px;
  }
  @media (max-width: 995px) {
    padding-bottom: 0px;
    width: 100%;
  }
}
.carousel-full__copy-column--1,
.carousel-full__copy-column--2 {
  @media (max-width: $width--xs) {
    width: 100%;
  }
}
.carousel-full__copy-columns {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  margin-top: 40px;
  @media (max-width: 995px) {
    @include flex-direction(column);
    width: 100%;
  }
}
.img-1 {
  width: 300px !important;
  top: 210px !important;
}
.img-2 {
  width: 300px !important;
  top: 210px !important;
}
.carousel-full__img--serve {
  z-index: 100;

  @media (max-width: 995px) {
    position: relative !important;
    top: 0 !important;
    max-width: 100px;
    .next-arrow {
      top: 300px !important;
      height: 100px !important;
    }
  }
}
.carousel-full__h1 {
  font-family: termina, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
  padding-bottom: 25px;
  margin-top: 50px;
  text-align: center;
  width: 100%;
  @media (max-width: 995px) {
    padding: 0px 25px 50px 25px;
  }
}
.carousel-full__h2 {
  font-family: termina, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  width: 220px;
  @media (max-width: 995px) {
    margin-bottom: 20px;
    width: 100%;
  }
  @media (max-width: $width--xs) {
    text-align: center !important;
    width: 100%;
  }
}
.carousel-full__p {
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 18px;
  &:not(:first-child) {
    margin-top: 5px;
  }
  @media (max-width: 995px) {
    text-align: center !important;
    width: 100%;
  }
}
.carousel-full__p--additional {
  margin-top: 40px !important;
}
.carousel-full__units {
  font-size: 10px;
  line-height: 14px;
  margin-top: 40px;
  padding-bottom: 150px;
  @media (max-width: $width--xs) {
    text-align: center !important;
    width: 100%;
  }
}
.carousel-full__bottomBorder {
  bottom: 0px;
  z-index: -1;
  position: absolute;
}

@media screen and(max-width: 670px) {
  .right-side {
    margin-top: 75px;
  }
  .gold-bg {
    margin-left: -20px;

    width: 290px;
    top: 70px !important;
  }
  .gold-bg-2 {
    margin-left: 0px !important;
  }
  .slick-slide img {
    display: initial !important;
  }
  .slide-wrapper {
    flex-direction: column !important;
    margin-bottom: 50px;
  }
  .carousel-full {
    min-height: 400px !important;
  }
  .serve-img {
    width: 290px !important;
    //margin-top: 150px !important;
  }
  .serve-text-img {
    position: absolute;
    z-index: 100;
    top: 210px;
    width: 165px !important;
    margin-top: 25px !important;
  }
  .serve-text-img-6 {
    top: 230px !important;
    width: 190px !important;
  }
  .serve-img-1 {
    margin-left: 10px !important;
  }
  .serve-img-2 {
    margin-left: 10px !important;
  }
  .serve-img-3 {
    margin-left: 15px !important;
  }
  .serve-text-img-1 {
    top: 230px !important;
  }
  .serve-text-img-2 {
    top: 250px !important;
  }
  .serve-text-img-3 {
    top: 225px !important;
    width: 180px !important;
  }
  .serve-text-img-4 {
    top: 250px !important;
    width: 245px !important;
  }
  .recipe-btn {
    width: 200px !important;
  }
  .buy-btn {
    width: 200px !important;
  }
  .left-side {
    height: 370px !important;
    width: 100% !important;
    background-size: 35% auto !important;
    background-position-y: 50px !important;
    background-position-x: 195px !important;
  }
  .right-side {
    width: 195px !important;
  }
}

#next-arrow {
  position: absolute;
  right: 25px;
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
#prev-arrow {
  position: absolute;
  left: 25px;
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.width--100p {
  width: 100%;
}
.slick-slider {
  margin-bottom: 0px;
}
@-webkit-keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
